import React from 'react';

export default function SmartiLabBadge({ label, variant = 'neutral', subtle = false }) {
  const className = ['sl-badge', `sl-badge-${variant}`, subtle ? 'subtle' : ''].filter(Boolean).join(' ');
  return <span className={className}>{label}</span>;
}
